import { defaultFetch } from './baseApi';

export type StatusOwnerType = {
	userId: number;
	email: string;
	firstName: string;
	lastName: string;
	invoiceCount: number;
};

export const getOwnershipStatus = (projectId: string) => {
	return defaultFetch<StatusOwnerType[]>(`/v0/projects/${projectId}/ownershipinvoicesstatus`);
};

export const getOwnershipStatusForSampling = (projectId: string, samplingId: number) => {
	return defaultFetch<StatusOwnerType[]>(`/v0/projects/${projectId}/samples/${samplingId}/ownershipstatus`);
};

export const assignMassiveOwnership = async (projectId: string, userIds: number[]) => {
	return defaultFetch(`/v0/projects/${projectId}/assigninvoicesownership`, {
		method: 'POST',
		body: JSON.stringify({ userIds }),
	});
};

export const assignMassiveOwnershipForSampling = async (projectId: string, samplingId: number, userIds: number[]) => {
	return defaultFetch(`/v0/projects/${projectId}/samples/${samplingId}/assignownership`, {
		method: 'POST',
		body: JSON.stringify({ userIds }),
	});
};

export const assignOwnershipOnSingleInvoice = async (projectId: string, invoiceId: number, userIds: number[]) => {
	return defaultFetch(`/v0/projects/${projectId}/invoices/${invoiceId}/assignownership`, {
		method: 'POST',
		body: JSON.stringify({ userIds }),
	});
};
